module.exports = __webpack_public_path__ + "img/eye-intelligence-reports.fda5a2b9.png";